import React, { useState } from "react";
import { AnimatePresence } from "framer-motion";
import {
  AccordionContent,
  AccordionHeader,
  AccordionWrapper,
  Title,
} from "./style";
import { FlexDiv } from "../../Box";

export const AccordionV2 = ({
  title,
  children,
}: {
  title: string;
  children: JSX.Element;
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  return (
    <AccordionWrapper
      style={{
        paddingBottom: isOpen ? "24px" : "8px",
      }}
    >
      <AccordionHeader onClick={toggleAccordion}>
        <Title variant="label1">{title}</Title>

        {isOpen ? (
          <FlexDiv
            style={{
              width: "32px",
              height: "32px",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <svg
              style={{
                cursor: "pointer",
              }}
              width="32"
              height="32"
              viewBox="0 0 32 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.0503 11.0502L20.9498 20.9497"
                stroke="#6E55D3"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M11.0503 20.9498L20.9498 11.0503"
                stroke="#6E55D3"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </FlexDiv>
        ) : (
          <FlexDiv
            style={{
              width: "32px",
              height: "32px",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <svg
              style={{
                cursor: "pointer",
              }}
              width="32"
              height="32"
              viewBox="0 0 32 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M16 9V23"
                stroke="#6E55D3"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M9 16H23"
                stroke="#6E55D3"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </FlexDiv>
        )}
      </AccordionHeader>
      <AnimatePresence>
        {isOpen && (
          <AccordionContent
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
          >
            {children}
          </AccordionContent>
        )}
      </AnimatePresence>
    </AccordionWrapper>
  );
};
